<template>
  <div class="space-y-6">
    <div class="text-center">
      <h2 class="text-2xl sm:text-3xl font-bold text-neutral-900 dark:text-white mb-2">
        {{ $t('auth.forgotPasswordTitle') }}
      </h2>
      <p class="text-sm sm:text-base text-neutral-600 dark:text-neutral-300">
        {{ $t('auth.forgotPasswordSubtitle') }}
      </p>
    </div>

    <form class="space-y-4" @submit.prevent="submit">
      <div>
        <label for="email" class="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-1">
          {{ $t('auth.email') }}
        </label>
        <input
          id="email"
          v-model="email"
          type="email"
          required
          autocomplete="email"
          class="input w-full"
          :placeholder="$t('auth.emailPlaceholder')"
        />
      </div>

      <div v-if="error" class="rounded-lg bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 p-3">
        <p class="text-sm text-red-700 dark:text-red-300">{{ error }}</p>
      </div>

      <div v-if="sent" class="rounded-lg bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 p-3">
        <p class="text-sm text-green-700 dark:text-green-300">{{ $t('auth.forgotPasswordSent') }}</p>
      </div>

      <button type="submit" class="btn-primary w-full" :disabled="loading || sent">
        {{ loading ? $t('common.loading') : $t('auth.forgotPasswordSubmit') }}
      </button>

      <p class="text-center">
        <router-link to="/auth/login" class="text-sm text-primary-600 hover:text-primary-700 dark:text-primary-400">
          {{ $t('auth.backToLogin') }}
        </router-link>
      </p>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { apiService } from '@/services/api'

const { t } = useI18n()
const email = ref('')
const loading = ref(false)
const error = ref('')
const sent = ref(false)

const submit = async () => {
  loading.value = true
  error.value = ''
  try {
    const res = await apiService.auth.forgotPassword({ email: email.value.trim() })
    if (res.success) {
      sent.value = true
    } else {
      error.value = res.message || t('auth.forgotPasswordError')
    }
  } catch (e) {
    error.value = e?.message || t('auth.forgotPasswordError')
  } finally {
    loading.value = false
  }
}
</script>
